import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  SearchRequestDefaults: {
    ...shopifyGenericDefaults.SearchRequestDefaults,
    sort: 'price:desc',
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => w.name !== 'SearchBoxDialogButton'),
    {
      name: 'SearchBoxDialogButton',
      location: {
        selector: '#cm-mobile-search-box',
        class: 'cm-mobile-search-box',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
  ],
};
